export default __webpack_public_path__ + "static/media/daniSignature.b9a047a5.png";